import { Link } from "react-router";

export type DocumentSection = {
  title: string;
  body?: string;
  items?: string[];
};

type DocumentPageProps = {
  eyebrow: string;
  title: string;
  description: string;
  sections: DocumentSection[];
  footer?: string;
};

export function DocumentPage({ eyebrow, title, description, sections, footer }: DocumentPageProps) {
  return (
    <main className="min-h-screen bg-[#f7efe6] px-5 py-8 text-stone-950 sm:px-8">
      <div className="mx-auto max-w-4xl">
        <header className="mb-8 flex flex-col gap-4 border-b border-stone-900/10 pb-6 sm:flex-row sm:items-center sm:justify-between">
          <Link to="/" className="text-lg font-black tracking-[-0.03em]">
            앤트
          </Link>
          <nav className="flex flex-wrap gap-3 text-sm font-semibold text-stone-700">
            <Link className="transition-colors hover:text-stone-950" to="/privacy-policy">
              개인정보 처리 방침
            </Link>
            <Link className="transition-colors hover:text-stone-950" to="/terms">
              이용 약관
            </Link>
          </nav>
        </header>

        <article className="rounded-[1.5rem] border border-white/70 bg-white/75 p-6 shadow-[0_24px_70px_rgba(126,92,55,0.08)] sm:p-10">
          <p className="text-sm font-semibold uppercase tracking-[0.26em] text-amber-700/75">{eyebrow}</p>
          <h1 className="mt-3 text-3xl font-black tracking-[-0.04em] sm:text-5xl">{title}</h1>
          <p className="mt-5 whitespace-pre-line text-base leading-8 text-stone-700">{description}</p>

          <div className="my-8 h-px bg-stone-900/10" />

          <div className="space-y-8">
            {sections.map(section => (
              <section key={section.title}>
                <h2 className="text-xl font-black tracking-[-0.03em] text-stone-950">{section.title}</h2>
                {section.body ? <p className="mt-3 whitespace-pre-line text-sm leading-7 text-stone-700">{section.body}</p> : null}
                {section.items ? (
                  <ul className="mt-3 list-disc space-y-2 pl-5 text-sm leading-7 text-stone-700">
                    {section.items.map(item => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                ) : null}
              </section>
            ))}
          </div>

          {footer ? (
            <>
              <div className="my-8 h-px bg-stone-900/10" />
              <p className="whitespace-pre-line text-sm leading-7 text-stone-700">{footer}</p>
            </>
          ) : null}
        </article>
      </div>
    </main>
  );
}
